import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';

export default function PageNotFound() {
  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
      }}>
      <Paper
        elevation={3}
        style={{ padding: '20px', textAlign: 'center' }}>
        <Typography
          variant="h5"
          color="error">
          404: Page Not Found
        </Typography>
      </Paper>
    </div>
  );
}
